import jsPDF from "jspdf";
import { getUserFromLocalStorage } from "@/utils/getUserFromLocalStorage";
import headerLogo from "../../../../assets/png/gav-extended.png";

interface PdfGeneratorProps {
  fileName: string;
  bodyContent: (doc: jsPDF) => void;
  pageSize?: "a4" | "letter";
  headerContent?: (doc: jsPDF) => void;
  footerContent?: (doc: jsPDF) => void;
}

const PdfGenerator = ({
  fileName,
  bodyContent,
  pageSize = "a4",
  headerContent,
  footerContent,
}: PdfGeneratorProps) => {
  const generatePdf = () => {
    const user = getUserFromLocalStorage();

    const doc = new jsPDF({ format: pageSize });

    const pageWidth = doc.internal.pageSize.width;
    const pageHeight = doc.internal.pageSize.height;

    if (headerContent) {
      headerContent(doc);
    } else {
      const headerHeight = 20;
      doc.setFillColor(245, 203, 43);
      doc.rect(0, 0, pageWidth, headerHeight, "F");

      const headerLogoWidth = 50;
      const headerLogoHeight = 12;
      const logoX = 10;
      const logoY = (headerHeight - headerLogoHeight) / 2;
      doc.addImage(
        headerLogo,
        "PNG",
        logoX,
        logoY,
        headerLogoWidth,
        headerLogoHeight
      );
    }

    if (bodyContent) {
      bodyContent(doc);
    }

    if (footerContent) {
      footerContent(doc);
    } else {
      const footerY = pageHeight - 30;
      doc.setFontSize(10);
      doc.setLineWidth(0.5);
      doc.line(10, footerY, pageWidth - 10, footerY);

      doc.text(
        `Esse arquivo foi gerado em ${new Date().toLocaleString(
          "pt-BR"
        )}, por ${user.name || "Desconhecido"}.`,
        10,
        footerY + 10
      );
      doc.text(`Página 1`, pageWidth - 40, footerY + 10);
    }

    const formattedFileName = `${fileName}_${new Date()
      .toLocaleString("pt-BR")
      .replace(/[/\s:]/g, "_")}.pdf`;

    doc.save(formattedFileName);
  };

  return generatePdf;
};

export default PdfGenerator;
